import {
  LINKS_LIST,
  UPDATE_LINK,
  ADD_LINK,
  REMOVE_LINK,
  MOVE_LINK,
  MOVE_LINK_ERROR,
} from './types';
import { Account } from './api';

const handleUpdateLink = (state, action) => {
  state.forEach((element, index) => {
    if (element.id === action.id) {
      state[index] = action;
    }
  });
  return state;
};

export const linksListAction = id => async dispatch => {
  const response = await Account.linksList(id);
  if (!response.error) {
    dispatch({ type: LINKS_LIST, payload: response });
  } else {
    return response.error;
  }
};

export const updateLinkAction = (accId, param) => async (
  dispatch,
  getState,
) => {
  const { links } = getState();
  const oldLinks = links.linksList;
  const response = await Account.updateLink(accId, param);

  if (!response.error) {
    const newLinks = handleUpdateLink(oldLinks, response);
    dispatch({ type: UPDATE_LINK, payload: newLinks });
    return { status: 'success' };
  } else {
    return response.error;
  }
};

export const addLinkAction = (id, param) => async dispatch => {
  const response = await Account.addLink(id, param);

  if (!response.error) {
    dispatch({ type: ADD_LINK, payload: response });
    return { status: 'success' };
  } else {
    return response.error;
  }
};

export const moveLinkAction = (id, param) => async dispatch => {
  dispatch({ type: MOVE_LINK, payload: param });

  const response = await Account.moveLink(id, param);

  if (response.error) {
    dispatch({
      type: MOVE_LINK_ERROR,
      payload: {
        startIndex: param.endIndex,
        endIndex: param.startIndex,
      },
    });
    return response.error;
  } else {
    return { status: 'success' };
  }
};

export const removeLinkAction = (accId, id) => async dispatch => {
  const response = await Account.removeLink(accId, id);

  if (!response.error) {
    dispatch({ type: REMOVE_LINK, payload: { id } });
    return { status: 'success' };
  } else {
    return response.error;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/links/actions.js